var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fixed inset-0 z-230 transition-opacity duration-500",style:(_setup.overlayStyle)},[_c('div',{staticClass:"relative transition-all duration-300 ease-out",style:({
      ..._setup.spotlightStyle,
      boxShadow: _setup.spotlightBoxShadow,
      willChange: 'transform',
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }